import { render } from "./Sidebar.vue?vue&type=template&id=9482ca32"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=9482ca32&lang=css"

import exportComponent from "C:\\Users\\oozdemir\\Documents\\GitHub\\bootstrap-sample\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__